.iv-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.iv-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  padding: 2rem;
  min-width: 320px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.iv-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #333;
}

.iv-modal-wishlist {
  margin-top: 1rem;
}

.iv-modal-wishlist-item {
  border-bottom: 1px solid #eee;
  padding: 1rem 0;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.iv-modal-wishlist-field {
  font-size: 1rem;
  color: #222;
}

.iv-modal-wishlist-empty {
  text-align: center;
  color: #888;
  padding: 2rem 0;
}
